/**
 * Hub for documented features that have placeholder pages (Phase 2).
 * All routes exist; this page helps discovery.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';

const FEATURES: { path: string; label: string; icon: string; tier?: string }[] = [
  { path: '/vault', label: 'Vault', icon: '🔒', tier: 'Pro+' },
  { path: '/activity', label: 'Activity Tracking', icon: '📊' },
  { path: '/location-sharing', label: 'Location Sharing', icon: '📍', tier: 'Pro+' },
  { path: '/image-sharing', label: 'Image Sharing', icon: '🖼️' },
  { path: '/collaborative-work', label: 'Collaborative Work', icon: '👥', tier: 'Pro+' },
  { path: '/family-groups', label: 'Family Groups', icon: '👨‍👩‍👧‍👦' },
  { path: '/shared-living', label: 'Shared Living', icon: '🏠', tier: 'Pro+' },
  { path: '/group-planning', label: 'Group Planning', icon: '📋' },
  { path: '/healthcare', label: 'Healthcare', icon: '🏥', tier: 'Pro+' },
  { path: '/education', label: 'Education', icon: '📚', tier: 'Pro+' },
  { path: '/licenses', label: 'License Management', icon: '📜', tier: 'Pro+' },
  { path: '/art', label: 'Art & Creations', icon: '🎨', tier: 'Pro+' },
  { path: '/personal-inventory', label: 'Personal Inventory', icon: '📋', tier: 'Pro+' },
  { path: '/trust-score', label: 'Trust Score', icon: '🛡️' },
  { path: '/blockchain', label: 'Blockchain', icon: '⛓️' },
];

const MoreFeatures: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: '16px',
        padding: '24px',
        marginBottom: '24px',
        color: 'white',
      }}>
        <h1 style={{ margin: '0 0 8px 0', fontSize: '26px' }}>✨ More features</h1>
        <p style={{ margin: 0, opacity: 0.95, fontSize: '15px' }}>
          Placeholder pages for upcoming features. Tap to open.
        </p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px' }}>
        {FEATURES.map(({ path, label, icon, tier }) => (
          <button
            key={path}
            onClick={() => navigate(path)}
            style={{
              padding: '20px',
              background: 'white',
              border: '1px solid #e0e0e0',
              borderRadius: '12px',
              cursor: 'pointer',
              textAlign: 'left',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            }}
          >
            <span style={{ fontSize: '28px', display: 'block', marginBottom: '8px' }}>{icon}</span>
            <span style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>{label}</span>
            {tier && <span style={{ display: 'block', fontSize: '12px', color: '#888', marginTop: '4px' }}>{tier}</span>}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MoreFeatures;
